import { combineReducers } from 'redux';
import project from './project/projectSlice';
import template from './template/templateSlice';
import results from './project/resultsSlice';

export default combineReducers({
    template,
    project,
    results
});
